import { render, staticRenderFns } from "./ExpensesTypeFilter.vue?vue&type=template&id=fa8541ea&"
import script from "./ExpensesTypeFilter.vue?vue&type=script&lang=js&"
export * from "./ExpensesTypeFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports